module.exports = __webpack_public_path__ + "assets/img/026401.17894e79.png";